export const searchList = [
  {
    type: 'input',
    title: 'Дансны дугаар',
    children: {
      queryKey: 'dans_dugaar',
    },
  },
  {
    type: 'input',
    title: 'Хөрөнгийн код, нэр',
    children: {
      queryKey: 'hurungu',
    },
  },
];
